import DeleteIcon from "@mui/icons-material/Delete";
import { Typography } from "@mui/material";
import { memo } from "react";
import { useSonho } from "../../services/sonhos";
import { Sonho } from "../../types";
import { CDialog } from "../data-display";

interface ModalDeleteSonhoProps {
  data: Sonho;
}

export const ModalDeleteSonho = memo(({ data }: ModalDeleteSonhoProps) => {
  const { deleteSonho } = useSonho();

  const handleDelete = async () => {
    await deleteSonho(data);
  };

  return (
    <CDialog
      title="Deletando Item"
      onSave={handleDelete}
      iconButton={<DeleteIcon color="error" />}
      type="error"
    >
      <Typography variant="subtitle1">
        Você tem certeza que deseja deletar o item {data.title}?
      </Typography>
    </CDialog>
  );
});
